import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { withHeaderStyling, withAllColumnsWidth, withColumnsWithValuesWidth } from '../../utils';
import { getHeaders } from './headers';
import { getPreparedData } from './mappings';
import { getColumnsWidths } from './styles';
import { getMembersSheet } from '../company-members/company-members-template';
import { CompanyWithRoundsDTO } from 'src/app/domain/company/dto/CompanyWithRoundsDTO';

export class CompaniesTemplate implements ExcelTemplate {
  export(companies: CompanyWithRoundsDTO[]): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(companies);
    const withEmployee = companies.filter((c) => c.companyMembers?.length).length > 0;
    XLSX.utils.book_append_sheet(book, sheet, 'Companies');
    if (withEmployee) {
      const sheetMembers = getMembersSheet(companies);
      XLSX.utils.book_append_sheet(book, sheetMembers, 'Members');
    }
    return book;
  }

  /**
   * Here I'm using array of arrays, because I need prepare cells properly with
   * format, styles, etc.
   */
  private getSheet(companies: CompanyWithRoundsDTO[]): XLSX.WorkSheet {
    const headers = getHeaders();
    const preparedData = getPreparedData(companies, headers);
    const sheet = XLSX.utils.aoa_to_sheet(preparedData);
    return withColumnsWithValuesWidth(withAllColumnsWidth(withHeaderStyling(sheet)),
      getColumnsWidths());

  }
}


